export const UNSET_FORM_SUBMITTED = 'checkout-unset-form-submitted';
const unsetFormSubmitted = () =>({ type: UNSET_FORM_SUBMITTED });
export default unsetFormSubmitted;
